import PropertyGrid from "@/components/PropertyGrid";
import { useNavigate } from "react-router-dom";
import { properties } from "@/data/properties";
import Header from "@/components/Header";
import { usePublishedProperties } from "@/hooks/usePublishedProperties";
import { getPriceAmount } from "@/utils/price";

const Locales = () => {
  const navigate = useNavigate();
  const publishedProperties = usePublishedProperties();
  const allProperties = [...publishedProperties, ...properties];

  const locales = allProperties.filter((property) => {
    if (property.type !== "local") return false;
    return Number.isFinite(getPriceAmount(property));
  });

  return (
    <>
      <Header />
      <div className="w-full pt-24">
        <button
          type="button"
          onClick={() => navigate("/")}
          aria-label="Volver al inicio"
          className="fixed right-4 top-20 z-40 flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 bg-white text-sm font-black text-slate-600 shadow-sm"
        >
          X
        </button>
        <div className="mx-auto max-w-7xl px-4">
          <PropertyGrid
            properties={locales}
            loading={false}
            selectedCategory="local"
            showCategories={false}
            onCategoryChange={() => {}}
            onPropertyClick={(property) => navigate(`/propiedad/${property.id}`)}
            title="Locales Comerciales"
            subtitle="Espacios ideales para tu negocio"
          />
        </div>
      </div>
    </>
  );
};

export default Locales;
